import * as React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { getOne } from "@/api/contentful";
import Article from "@/components/Article";
import { GetStaticProps, NextPage } from "next";
import PageSEO from "@/components/Shared/PageSEO";
import { ABOUT_US, ABOUT_US_SEO } from "@/data/consts";
import HeaderContent from "@/components/Header/Article/HeaderContent";
import { Article as ArticleType, PageSEO as PageSEOType } from "@/types/index";

const Breadcrumbs = [
	{
		title: "Home",
		href: "/",
		active: false,
	},
	{
		title: "About Us",
		href: "/about-us",
		active: true,
	},
];

const AboutUs: NextPage<{
	pageSEO: PageSEOType;
	article: ArticleType;
}> = ({ pageSEO, article }) => {
	return (
		<>
			<PageSEO
				title={pageSEO.fields.pageTitle}
				description={pageSEO.fields.metaDescription}
				keywords={pageSEO.fields.metaKeywords}
			/>
			<Header
				left={<HeaderContent title={article.fields.title} />}
				right={<></>}
				breadcrumbs={Breadcrumbs}
			/>
			<Article article={article} showAuthor={false} showSideBar={false} />
			<Footer />
		</>
	);
};

export const getStaticProps: GetStaticProps = async () => {
	const pageSEO = await getOne(ABOUT_US_SEO);
	const article: ArticleType = await getOne(ABOUT_US);

	return {
		props: {
			pageSEO,
			article,
		},
		revalidate: Number(process.env.REVALIDATE_CONTENTFUL),
	};
};

export default AboutUs;
